import React from "react";
// import customMakeStyle from "../../../styles/customMakeStyle";

import { ResponsiveContainer, PieChart, Pie, Cell, Sector } from "recharts";

// import alphaFunction from "../mui-abstraction/alphaFunction";

/**
 * 3 props, data, colorProperty, valueProperty
 * data - Specifies data, an array
 * format =>  [{
    value: 34,
    color: "#FABE58",
    }, ...]
 * colorProperty - Defines color property of each data array's object for each portion of the pie chart, 
 * default value "color"
 * valueProperty - Defines value property of each data array's object for each portion of the pie chart, 
 * default value "value"
 */

// const RADIAN = Math.PI / 180;

// const useStyles = customMakeStyle((theme) => ({
//   legendStylePieChart: {
//     fontWeight: 400,
//     fontSize: 10,
//     fill: alphaFunction(theme.palette.primary.main, 0.85),
//     zIndex: 10,
//   },
//   legendValueStylePieChart: {
//     fontWeight: 400,
//     fontSize: 12,
//     fill: theme.palette.primary.main,
//   },
// }));

// const RenderCustomizedLabelLine = function (props) {
//   return props.value !== 0 ? (
//     <path
//       stroke={props.stroke}
//       d={`M${props.points[0].x},${props.points[0].y}L${props.points[1].x},${props.points[1].y}`}
//       className="customized-label-line"
//     />
//   ) : (
//     <polyline stroke={props.stroke} fill="none" />
//   );
// };

// function RenderCustomizedLabel({
//   cx,
//   cy,
//   midAngle,
//   innerRadius,
//   outerRadius,
//   percent,
//   chartData,
//   index,
//   labelProperty,
//   labelParcent,
//   labelValue,
// }) {
//   const styles = useStyles();
//   const radius = innerRadius + (outerRadius - innerRadius) + 25;
//   const x = cx + radius * Math.cos(-midAngle * RADIAN);
//   const y = cy + radius * Math.sin(-midAngle * RADIAN);
//   const label = chartData[index][labelProperty];

//   return (
//     <>
//       <text
//         x={x}
//         y={y}
//         textAnchor={midAngle < -90 || midAngle >= 90 ? "end" : "start"}
//         dominantBaseline="central"
//         className={styles.legendStylePieChart}
//       >
//         {label}
//       </text>
//       <text
//         x={x}
//         y={y}
//         dy={12}
//         textAnchor={midAngle < -90 || midAngle >= 90 ? "end" : "start"}
//         dominantBaseline="central"
//         className={styles.legendValueStylePieChart}
//       >
//         {labelParcent ? `${(percent * 100).toFixed(2)}%` : labelValue}
//       </text>
//     </>
//   );
// }

const renderActiveShape = (props) => {
  const {
    cx,
    cy,
    // midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    //value,
  } = props;
  // const sin = Math.sin(-RADIAN * midAngle);
  // const cos = Math.cos(-RADIAN * midAngle);
  // const sx = cx + (outerRadius + 5) * cos;
  // const sy = cy + (outerRadius + 5) * sin;
  // const mx = cx + (outerRadius + 15) * cos;
  // const my = cy + (outerRadius + 15) * sin;
  // const ex = mx + (cos >= 0 ? 1 : -1) * 10;
  // const ey = my;
  // const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text
        x={cx}
        y={cy}
        dy={12}
        textAnchor="middle"
        fill={"rgba(54, 43, 115, 1)"}
        style={{ fontFamily: "Inter", fontSize: 24, fontWeight: 500 }}
      >
        {(percent * 100).toFixed(2) + " %"}
      </text>
      <text
        x={cx}
        y={cy}
        dy={32}
        textAnchor="middle"
        fill="rgba(54, 43, 115, 1)"
        style={{ fontFamily: "Inter", fontSize: 12, fontWeight: 500 }}
      >
        {`${payload.subLabelValue}`}
      </text>
      <text
        x={cx}
        y={cy}
        dy={-20}
        textAnchor="middle"
        fill="rgba(54, 43, 115, 0.56)"
        style={{ fontFamily: "Inter", fontSize: 12, fontWeight: 500 }}
      >
        {`${payload.labelValue}`}
      </text>

      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
        // cornerRadius={10}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={innerRadius - 2}
        outerRadius={outerRadius + 2}
        fill={fill}
        // cornerRadius={20}
      />
      {/* <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      /> */}
      {/* <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" /> */}
    </g>
  );
};

const DonutChart = (props) => {
  const {
    data,
    colorProperty,
    valueProperty,
    // labelFlag,
    // labelProperty,
    // labelParcent,
  } = props;

  const [activeIndex, setActiveIndex] = React.useState(0);

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  return (
    <div style={{ overflow: "visble" }}>
      <ResponsiveContainer width={300} aspect={1}>
        <PieChart>
          <Pie
            startAngle={90}
            endAngle={-450}
            data={data}
            cx="50%"
            cy="50%"
            outerRadius="80%"
            innerRadius="60%"
            dataKey={valueProperty}
            paddingAngle={0}
            labelLine={false}
            //labelLine={RenderCustomizedLabelLine}
            // label={
            //   labelFlag ? (
            //     <RenderCustomizedLabel
            //       chartData={data}
            //       labelProperty={labelProperty}
            //       labelParcent={labelParcent}
            //     />
            //   ) : (
            //     ""
            //   )
            // }
            activeIndex={activeIndex}
            activeShape={renderActiveShape}
            onMouseEnter={onPieEnter}
            // cornerRadius={10}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry[colorProperty]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

DonutChart.defaultProps = {
  colorProperty: "color",
  valueProperty: "value",
  labelFlag: true,
  labelProperty: "label",
  labelParcent: false,
};

export default DonutChart;
